<template>
  <div>
    <Header type="questionnaire" />
    <div class="block">


      <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">Slide 1</div>
            <div class="swiper-slide">Slide 2</div>
            <div class="swiper-slide">Slide 3</div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        
        <!-- 如果需要导航按钮 -->
        <button id="prev" class="swiper-button-prev">1</button>
        <button id="next" class="swiper-button-next">2</button>
        
        <!-- 如果需要滚动条 -->
        <div class="swiper-scrollbar"></div>
    </div>


      <router-view />
    </div>
    <Progress />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Progress from '@/components/Progress.vue'

import Swiper from 'swiper/js/swiper';
import 'swiper/css/swiper.css'

   

export default {
  name: "Questionnaire",
  components: {
    Header,
    Progress,
  },
  data() {
    return {
      aaa:''
    }
  },
  mounted(){
    var mySwiper = new Swiper ('.swiper-container', {
      loop: true,
      // 如果需要分页器
      pagination: '.swiper-pagination',
      // 如果需要前进后退按钮
      nextButton: '#next',
      prevButton: '#prev',
      // 如果需要滚动条
      scrollbar: '.swiper-scrollbar',
    })        
    mySwiper.slideNext()
  },
  methods: {
    ax(){
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.block{
  padding: 10%;
  .swiper {
    width: 600px;
    height: 300px;
  }  
  .swiper-container{
    overflow: hidden;
  }
  .swiper-button-prev{
    background: red;
  }
  .swiper-button-next{
    background: blue;
  }
}
</style>
